module.exports = {
	"pagination": {
		"ListCollections": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"limit_key": "MaxResults",
			"result_key": "CollectionIds"
		},
		"ListFaces": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"limit_key": "MaxResults",
			"result_key": "Faces"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/rekognition-2016-06-27.paginators.json
// module id = 686
// module chunks = 0 1 2 3 4 6 7 8